export const en = {
    'ad-decline-req': 'The groups have been rejected because they do not follow the rules for advertising.',
    'how-to-fix': 'Find out how to fix the group in the "Status" column.',
    'many-group-title': 'Change {count} groups so they can pass moderation',
    'one-group-title': 'Change {count} group so it can pass moderation',
    'one-group-title-hint': 'The recommendation is shown because the group has not passed moderation',
    'open-ad-list': 'To find out the reasons for rejection and correct them, check your ads and group settings.',
    'popup-ad-decline-req': 'The group has been rejected because it does not follow the rules for advertising.',
    'several-group-title-hint': 'The recommendation is shown because some groups have not passed moderation',
    'show-many-group-button': 'View {count} groups',
    'show-one-group-button': 'View {count} group',
    'show-some-group-button': 'View {count} groups',
    'simple-title': 'Change the group to pass moderation',
    'some-group-title': 'Change {count} groups so they pass moderation',
    'twenty-one-group-title': 'Change {count} group so it passes moderation'
};
